import Vue from 'vue'
import UiSkeleton from '../components/skeleton/UiSkeleton.vue'

class Skeleton {
  constructor (el) {
    this.el = el
    this.Skeleton = null
    this.isShow = false
  }

  show (props) {
    if (this.isShow) return

    this.Skeleton = this.createSkeleton()
    this.setProps(props)

    const skeletonElement = document.createElement('div')
    this.el.after(skeletonElement)
    this.el.remove()

    this.Skeleton.$mount(skeletonElement)

    this.isShow = true
  }

  hide () {
    if (!this.isShow) return
    this.Skeleton.$el.before(this.el)
    this.Skeleton.$el.remove()
    this.Skeleton.$destroy()
    this.Skeleton = null
    this.isShow = false
  }

  setProps (props) {
    if (!this.Skeleton) return
    const innerProps = { ...props }
    const style = getComputedStyle(this.el)

    if (!innerProps.height && !innerProps.text) {
      const height = this.el.clientHeight
      const lineHeight = parseFloat(style.lineHeight)
      // Считаем, что скелетон ставится на текст, если у элемента нет высоты или высота = высоте текста
      const isSkeletonForText = !height || (height === lineHeight)
      // Если скелетон ставится на текст, то передаём обработку в компонент скелетона через пропс "text"
      if (isSkeletonForText) innerProps.text = true
      else innerProps.height = height
    }

    if (!innerProps.borderRadius) {
      const borderRadius = parseInt(style.borderRadius)
      innerProps.borderRadius = borderRadius ?? null
    }

    innerProps.marginTop ??= parseFloat(style.marginTop)
    innerProps.marginBottom ??= parseFloat(style.marginBottom)
    innerProps.marginLeft ??= parseFloat(style.marginLeft)
    innerProps.marginRight ??= parseFloat(style.marginRight)
    innerProps.fontSize ??= parseFloat(style.fontSize)
    innerProps.lineHeight ??= parseFloat(style.lineHeight)

    Object.assign(this.Skeleton, innerProps)
  }

  createSkeleton () {
    const Skeleton = Vue.extend(UiSkeleton)
    return new Skeleton()
  }
}

const updateSkeleton = (skeleton, show, props = {}) => {
  if (show) skeleton.show(props)
  else skeleton.hide()
}

const onUpdate = (skeleton, value) => {
  if (typeof value === 'boolean') {
    updateSkeleton(skeleton, value)
    return
  }

  const { show, ...props } = value
  updateSkeleton(skeleton, show, props)
}

export default {
  inserted (el, { value }) {
    el.skeleton = new Skeleton(el)
    onUpdate(el.skeleton, value)
  },
  update (el, { value }) {
    onUpdate(el.skeleton, value)
  },
  unbind (el) {
    if (!el?.skeleton) return
    el.skeleton.hide()
    delete el.skeleton
  }
}
